var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3811 23.3808C14.7799 23.3795 17.1126 22.594 19.0236 21.1441C20.9347 19.6942 22.3194 17.6594 22.9668 15.3496C23.6142 13.0397 23.4888 10.5816 22.6097 8.3497C21.7306 6.11776 20.146 4.23438 18.0973 2.98648C16.0486 1.73858 13.6482 1.19458 11.2617 1.43735C8.87517 1.68013 6.63345 2.69637 4.87803 4.33126C3.12262 5.96614 1.94975 8.13004 1.53812 10.4933C1.12648 12.8565 1.49865 15.2895 2.59792 17.4217L1.37502 23.3808L7.33421 22.1579C8.89424 22.9641 10.6251 23.3835 12.3811 23.3808Z",
    stroke: "#303030",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.801f786339fd9c94e2d9eca6d2d89ddd.svg";
export { ForwardRef as ReactComponent };